<p-toast [life]="constantService.defaultToastLife"></p-toast>
<div class="move-upward" style="background-image: url(./images/login3.jpg)">
  <h1 class="rs">Regulatory Surveillance and Management System</h1>
  <div class="login-cntnt">
    <div class="login-box">
      <div class="log-bx-head defaultColor">
        <img src="./images/log-hed-ic.png" alt="login page">
        <h4>RSMS Login</h4>
      </div>
      <div class="log-bx-cntnt">
        <div class="alert alert-info">
          <router-outlet> </router-outlet>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <p class="text-muted">
      <strong>Copyright </strong>&copy; RSMS {{currentYear}} All rights reserved
    </p>
  </div>
</div>

<p-confirmDialog acceptLabel="Ok" key="confirmationDialog" [rejectVisible]="true" appendTo="body" header="Confirmation"
  icon="pi pi-exclamation-triangle" [baseZIndex]="999999" styleClass="confirm-dialog">
</p-confirmDialog>

<p-confirmDialog acceptLabel="Ok" key="informationDialoge" appendTo="body" header="Information"
  icon="pi pi-exclamation-triangle" [baseZIndex]="999999" styleClass="confirm-dialog">
</p-confirmDialog>